// Firebase configuration and initialization
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAItiFotuAufzkUxQpXDDS_j0OlZjYVFhk",
  authDomain: "lymet-agency-reg.firebaseapp.com",
  projectId: "lymet-agency-reg",
  storageBucket: "lymet-agency-reg.firebasestorage.app",
  messagingSenderId: "1005532623811",
  appId: "1:1005532623811:web:5c824e5ee708ac2aaf0376",
  measurementId: "G-MJH19PRD8G"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const db = getFirestore(app);
